/**
 * getters
 *
 * @Author  Carey.zhou
 * @DATE    create on 2019/9/16
 * @DESC
 */

export const getters = {
  /**
   * 获取总票数 免费票+充值票
   * @param state
   * @returns {number}
   */
  ticketTotal: state => {
    return state.freeTicket + state.rechargeTicket
  },

  /**
   * 是否是 vip 用户
   * @param state
   * @returns {boolean}
   */
  isVip: state => {
    return state.vipSurplusDays > 0
  },

  freeTicket: state => {
  return state.freeTicket
  },

  rechargeTicket: state => {
  return state.rechargeTicket
  },

  vipSurplusDays: state => {
  return state.vipSurplusDays
  },

  integral: state => {
  return state.integral
  },

  monthCardNum: state => {
  return state.monthCardNum
  },

  avatarUlr: state => {
    return state.avatarUlr
  },

  phone: state => {
    return state.phone
  },

  platform: state => {
    return state.platform
  }
}
